export enum EMutationKey {
  deleteInpsectionsLocalInspectionDB = 'deleteInspectionLocalInspectionDB',
  createInspection = 'createInspection',
  newObservation = 'newObservation',
  // Cache invalidation mutations
  invalidateInspections = 'invalidateInspections',
  invalidateAssets = 'invalidateAssets',
  invalidateCustomerSitesAssets = 'invalidateCustomerSitesAssets',
  syncInspectionData = 'syncInspectionData',
  // Observation mutation keys with cache invalidation
  upsertObservation = 'upsertObservation',
  deleteObservationByPath = 'deleteObservationByPath',
  deleteObservationsByProps = 'deleteObservationsByProps',
  deleteObservation = 'deleteObservation',
  batchedObservations = 'batchedObservations',
}
